<template>
  <div v-if="visible" class="print-preview-overlay" @click.self="close">
    <div class="print-preview-modal">
      <div class="modal-header">
        <h3>{{ $t('printerConfig.preview') }}</h3>
        <button class="close-btn" @click="close">✕</button>
      </div>

      <div class="receipt-preview">
        <!-- 小票头部 -->
        <div class="receipt-header">
          <h2 class="receipt-title">
            <span v-if="config.gstRegistered">Tax Invoice</span>
            <span v-else>Invoice</span>
          </h2>
          <p class="invoice-no">{{ $t('printerConfig.previewInvoiceNo') }}: {{ generateInvoiceNo() }}</p>
          <p class="invoice-date">{{ $t('printerConfig.previewDate') }}: {{ formatDate(new Date()) }}</p>
        </div>

        <!-- 批发商信息 -->
        <div v-if="config.showWholesalerInfo" class="receipt-section">
          <h4>{{ $t('printerConfig.previewSupplier') }}</h4>
          <p>{{ config.wholesalerName || '-' }}</p>
          <p>{{ config.wholesalerAddress || '-' }}</p>
          <p>{{ config.wholesalerPhone || '-' }}</p>
          <p v-if="config.gstRegistered">GST No: {{ config.gstNo || '-' }}</p>
          <p v-else-if="config.wholesalerTaxNo">Tax No: {{ config.wholesalerTaxNo }}</p>
        </div>

        <!-- 客户信息（从订单获取） -->
        <div v-if="config.showStallInfo" class="receipt-section">
          <h4>{{ $t('printerConfig.previewCustomer') }}</h4>
          <p>{{ order.stallName || '-' }}</p>
          <p>{{ order.deliveryAddress || '-' }}</p>
          <p>{{ order.receiverName || '-' }} {{ order.receiverPhone ? '(' + order.receiverPhone + ')' : '' }}</p>
          <p v-if="order.stallTaxNo">Tax No: {{ order.stallTaxNo }}</p>
          <p v-if="order.remark">{{ order.remark }}</p>
        </div>

        <!-- 商品列表（示例） -->
        <div class="receipt-section">
          <h4>{{ $t('printerConfig.previewItems') }}</h4>
          <table class="items-table">
            <thead>
              <tr>
                <th>{{ $t('printerConfig.previewItem') }}</th>
                <th>{{ $t('common.quantity') }}</th>
                <th>{{ $t('common.price') }}</th>
                <th>{{ $t('common.subtotal') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>示例商品<br/><small>Sample Product</small></td>
                <td>10</td>
                <td>S$ 5.00</td>
                <td>S$ 50.00</td>
              </tr>
              <tr>
                <td>示例商品 2<br/><small>Sample Product 2</small></td>
                <td>5</td>
                <td>S$ 8.00</td>
                <td>S$ 40.00</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 金额汇总 -->
        <div class="receipt-section amount-section">
          <div class="amount-row">
            <span>{{ $t('common.subtotal') }}</span>
            <span>S$ 90.00</span>
          </div>
          <div v-if="config.gstRegistered && config.showGstDetail" class="amount-row gst-row">
            <span>GST ({{ config.gstRate }}%)</span>
            <span>S$ {{ (90 * config.gstRate / 100).toFixed(2) }}</span>
          </div>
          <div class="amount-row total-row">
            <span>{{ $t('common.total') }}</span>
            <span>S$ {{ config.gstRegistered ? (90 + 90 * config.gstRate / 100).toFixed(2) : '90.00' }}</span>
          </div>
        </div>

        <!-- 银行信息 -->
        <div v-if="config.showBankInfo && config.bankName" class="receipt-section">
          <h4>{{ $t('printerConfig.previewBank') }}</h4>
          <p>{{ config.bankName }}</p>
          <p>{{ config.bankAccountName }}</p>
          <p>{{ config.bankAccountNumber }}</p>
        </div>

        <!-- PayNow 收款码 -->
        <div v-if="config.showPaynowQr && config.wholesalerPaynowQr" class="receipt-section qr-section">
          <h4>{{ $t('printerConfig.previewPaynow') }}</h4>
          <img :src="config.wholesalerPaynowQr" class="qr-image" />
        </div>



        <!-- 底部 -->
        <div class="receipt-footer">
          <p>{{ $t('printerConfig.previewThankYou') }}</p>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn-print" @click="printReceipt">🖨️ {{ $t('printerConfig.print') }}</button>
        <button class="btn-close" @click="close">{{ $t('common.close') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrintPreview',
  props: {
    visible: { type: Boolean, default: false },
    config: { type: Object, default: () => ({}) },
    order: { type: Object, default: () => ({}) }
  },
  methods: {
    close() {
      this.$emit('update:visible', false);
    },
    generateInvoiceNo() {
      const now = new Date();
      const y = now.getFullYear();
      const m = String(now.getMonth() + 1).padStart(2, '0');
      const d = String(now.getDate()).padStart(2, '0');
      const r = String(Math.floor(Math.random() * 10000)).padStart(4, '0');
      return `INV-${y}${m}${d}-${r}`;
    },
    formatDate(d) {
      if (this.$i18n && this.$i18n.locale === 'zh-CN') {
        return d.toLocaleDateString('zh-CN', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
      }
      return d.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
    },
    printReceipt() {
      // Capacitor APP 环境不调用 window.print()
      if (window.Capacitor) {
        this.$message.warning('APP 环境暂不支持打印，请使用网页版')
        return
      }
      window.print()
    }
  }
};
</script>

<style scoped>
.print-preview-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.print-preview-modal {
  background: #fff;
  border-radius: 16px;
  width: 100%;
  max-width: 420px;
  max-height: 85vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
}

.close-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: #f5f5f5;
  border-radius: 50%;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  background: #e8e8e8;
}

.receipt-preview {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  background: #fafafa;
}

.receipt-header {
  text-align: center;
  padding-bottom: 16px;
  border-bottom: 2px dashed #e0e0e0;
  margin-bottom: 16px;
}

.receipt-title {
  font-size: 22px;
  margin: 0 0 8px 0;
  color: #333;
}

.invoice-no,
.invoice-date {
  margin: 4px 0;
  font-size: 13px;
  color: #666;
}

.receipt-section {
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px dashed #e8e8e8;
}

.receipt-section:last-child {
  border-bottom: none;
}

.receipt-section h4 {
  margin: 0 0 8px 0;
  font-size: 14px;
  color: #667eea;
}

.receipt-section p {
  margin: 4px 0;
  font-size: 13px;
  color: #333;
}

.items-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.items-table th,
.items-table td {
  padding: 8px 4px;
  text-align: left;
  border-bottom: 1px solid #f0f0f0;
}

.items-table th {
  font-weight: 600;
  color: #666;
  font-size: 12px;
}

.items-table small {
  color: #999;
}

.amount-section {
  border-bottom: none;
}

.amount-row {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  font-size: 14px;
}

.gst-row {
  color: #667eea;
}

.total-row {
  border-top: 2px solid #667eea;
  padding-top: 10px;
  margin-top: 6px;
  font-size: 16px;
  font-weight: 700;
  color: #667eea;
}

.qr-section {
  text-align: center;
}

.qr-image {
  max-width: 180px;
  max-height: 180px;
  border-radius: 8px;
  margin-top: 8px;
}

.receipt-footer {
  text-align: center;
  padding-top: 16px;
  border-top: 2px dashed #e0e0e0;
}

.receipt-footer p {
  margin: 0;
  font-size: 14px;
  color: #999;
}

.modal-footer {
  display: flex;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid #eee;
  background: #fff;
}

.btn-print,
.btn-close {
  flex: 1;
  padding: 12px;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}

.btn-print {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
}

.btn-close {
  background: #f5f5f5;
  color: #666;
}
</style>